import { InfoCircleOutlined } from '@ant-design/icons'
import { Col, Grid, Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import KPopover from 'app/components/UI-Elements/DataDisplay/KPopover'
import { GenericObject, RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

const MachinesCell: React.FC<MemberProps<IRental>> = ({ member }) => {
  const { md } = Grid.useBreakpoint()
  const { tComponent } = ToolBox.useString()
  const { products } = member

  const translate = (id: string, values: GenericObject<number | string>) =>
    tComponent({
      componentType: 'core',
      componentName: 'machines_cell',
      recordType: RecordType.rental,
      id,
      values
    })

  const getMobileExtra = () => {
    const remainingProductCount = products.slice(3).length
    if (remainingProductCount > 0) {
      return `, + ${translate('more_machines', {
        count: remainingProductCount
      })}`
    } else {
      return ''
    }
  }

  return (
    <If condition={products?.length}>
      <Choose>
        <When condition={md}>
          <span>
            <KPopover
              placement="top"
              content={
                <Row>
                  {products.map((product, index) => (
                    <Col span={24} key={`${product.name}-${index}`}>
                      {product.name}
                    </Col>
                  ))}
                </Row>
              }>
              <InfoCircleOutlined className="mr-2" hidden={products.length <= 1} />
            </KPopover>
            {products[0].name}
          </span>
        </When>
        <Otherwise>
          {products
            .slice(0, 3)
            .map((product) => product.name)
            .join(', ')}
          {getMobileExtra()}
        </Otherwise>
      </Choose>
    </If>
  )
}

export default MachinesCell
